//import FindStudentList from "@/pages/comp/basic/student/frame/left_find_list";
import { useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import AddAttendPopup from "@/pages/comp/edu/attend/popup/add_attend";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import AttendStateFunc from "@/pcomponents/common/content/edu/attend/func/state_func";
import SearchArea from "./area/search";

const FindStudentList = forwardRef((props: any, ref) => {
  const myProps = {
    listOpt: {},
    show_key_arr: [],
    grid_opt: {},
    on_search_list: (inOptObj: any) => { },
    list: (inOptObj: any) => { },
    discover_select: (inOptObj: any) => { },//stu_info,discover_map,discover_map_arr
    discover_delete: (inOptObj: any) => { },//discover_map
    is_show_title: true,
    title_str: "원생목록",
    is_use_paging: true,
    is_show_search_area: true,
    show_search_key_arr: [],
    is_first_search: true,
    first_select_seq_arr: [],
    info_arr: [],
    search_bottom_area: "",
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  for (let i = 0; i < xColumnArr.x_column_list_arr.length; i++) {
    let x_column = xColumnArr.x_column_list_arr[i];
    if (myProps.show_key_arr.length > 0) {
      if (strFunc.str_in_array(x_column["key"], myProps.show_key_arr) != -1) {
        xColumnArr.x_column_list_arr[i].is_show = "1";
      }
    }
  }

  const listAggridRef = useRef<any>();
  let default_list_opt: any = {
    ...xColumnArr.list_opt,
    s_grade: ["student"],
    s_stu_state: "now",
    s_addon_class_user: "1",
    s_stu_lecture_seq: "",//user.user_grade == "master" ? "" : strFunc.get_storage_array("s_stu_lecture_seq", "", ",")
    s_addon_discover_map: "",
    s_addon_discover_map_start_date: "",
    s_addon_discover_map_end_date: "",
    s_addon_counsel_todo_tot: "",
    s_addon_counsel_start_date: "",
    s_addon_counsel_end_date: "",
    s_addon_attend: "",
    s_addon_attend_start_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    s_addon_attend_end_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    s_addon_todo: "",
    s_addon_todo_start_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    s_addon_todo_end_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    ...myProps.listOpt
  };
  if (myProps.is_use_paging) {
    default_list_opt["is_need_count"] = "1";
    default_list_opt["is_no_limit"] = "";
  }
  const [listOpt, setListOpt] = useState({ ...default_list_opt });

  const [infoArr, setInfoArr] = useState(myProps.info_arr);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "add_attend",
    attend_sort: "in",//in,out
    attend_sort_detail: "",
    attend_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    userInfoArr: [],
    title: "팝업",
    width: "450px",
    height: "60%",
  });

  useEffect(() => {
    if (user.user_seq) {
      list({});
    }
  }, [user.user_seq]);

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    list, setSelectFalseAll, setListOpt, getListOpt, get_select_arr,
    setSelectFalseByMatchColVal,
    setSelectFalseByUserSeq,
    go_select_by_select_seq_arr
  }));

  const list = (inOptObj: any) => {
    let tmpPageData = {
      ...listOpt,
      select_seq_arr: [],
      ...inOptObj
    };
    tmpPageData["sc"] = listAggridRef.current.getListSc();
    setListOpt(tmpPageData);
    myProps.on_search_list(tmpPageData);
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', tmpPageData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
          if (myProps.is_use_paging) {
            setCountInfo(response.data["data"]["count_info"]);
          }
          setTimeout(() => {
            if (tmpPageData.select_seq_arr && tmpPageData.select_seq_arr.length > 0) {
              go_select_by_select_seq_arr({
                select_seq_arr: tmpPageData.select_seq_arr
              });
            }
          }, 100);
        } else {

        }
      });
  };

  const get_select_arr = () => {
    let selected_row = listAggridRef.current.getSelectedRows();
    return selected_row;
  }
  const getListOpt = () => {
    return listOpt;
  };

  const deleteAttend = (dataArr: any, confirm_msg: string) => {
    if (!confirm(confirm_msg)) {
      return false;
    }
    let del_form_data = {
      "data_arr": dataArr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/attend/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
        } else {

        }
      });
  };

  const openAttendPopup = (attend_sort: string, attend_sort_detail: string, select_user: any) => {
    let pop_title = "등원";
    if (attend_sort == "out") {
      pop_title = "하원";
    }
    if (xColumnArr.select_arr.a_sort_detail) {
      for (let i = 0; i < xColumnArr.select_arr.a_sort_detail.length; i++) {
        let item = xColumnArr.select_arr.a_sort_detail[i];
        if (item.value == attend_sort_detail) {
          pop_title = item.text;
        }
      }
    }
    let selected_row = listAggridRef.current.getSelectedRows();
    if (!strFunc.is_empty(select_user)) {
      selected_row = [select_user];
    }
    if (selected_row.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }
    let attend_date = listOpt.s_addon_attend_start_date;
    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": pop_title,
      attend_sort: attend_sort,
      attend_sort_detail: attend_sort_detail,
      attend_date: attend_date,
      userInfoArr: selected_row,
    });
  };

  const getAttendInCellRenderBtns = (params: any) => {
    let attend_data = AttendStateFunc.get_attend_data_by_user_info({ user_info: params.data });
    let attend_in_btns = AttendStateFunc.select_arr.a_sort_detail.map((item, idx) => {
      let btn_class = "btn-s btn-gray";
      let attend_btn_style: any = {};
      let attend_text = item.text;
      let is_in_attned = false;
      if (attend_data.in && attend_data.in.a_sort_detail == item.value) {
        if (AttendStateFunc.attend_color_json[item.value]) {
          attend_btn_style["background"] = AttendStateFunc.attend_color_json[item.value].background;
          attend_text = attend_data.in.a_time.substring(0, 5);
          is_in_attned = true;
        }
      }
      if (attend_data.out && attend_data.out.a_sort_detail == item.value) {
        if (AttendStateFunc.attend_color_json[item.value]) {
          attend_btn_style["background"] = AttendStateFunc.attend_color_json[item.value].background;
          attend_text = attend_data.out.a_time.substring(0, 5);
        }
      }
      return (
        <button key={idx}
          className={btn_class + " ml-1 px-1"}
          style={attend_btn_style}
          onClick={() => {
            if (item.value == "out") {
              if (attend_data.out) {
                deleteAttend([attend_data.out], "하원 취소 하시겠습니까?");
              } else {
                if (attend_data.in) {
                  openAttendPopup("out", item.value, params.data);
                } else {
                  alert("등원 후 하원 처리가 가능합니다.");
                }
              }
            } else {
              if (is_in_attned) {
                deleteAttend([attend_data.in], "등원 취소 하시겠습니까?");
              } else {
                openAttendPopup("in", item.value, params.data);
              }
            }
          }}
        >{attend_text}</button>
      );
    });
    return attend_in_btns;
  };

  const go_select_by_select_seq_arr = (inData: any) => {
    let opt_obj = {
      select_seq_arr: [],
      ...inData
    };
    let select_seq_arr = opt_obj.select_seq_arr;
    if (listAggridRef.current) {
      let tmp_all_nodes = listAggridRef.current.getNodeRows();
      for (let i = 0; i < tmp_all_nodes.length; i++) {
        let tmp_node = tmp_all_nodes[i];
        if (strFunc.str_in_array(tmp_node.data["a_seq"], select_seq_arr) != -1) {
          tmp_node.setSelected(true);
        }
      }
    }
  };

  const setSelectFalseAll = () => {
    listAggridRef.current.setSelectFalseAll();
    myProps.list({
      "s_stu_user_seq": "",
    });
  };

  const setSelectFalseByUserSeq = (inData: any) => {
    let opt_obj = {
      user_seq_arr: [],
      ...inData
    };
    let user_seq_arr = opt_obj.user_seq_arr;
    if (listAggridRef.current) {
      let tmp_all_nodes = listAggridRef.current.getNodeRows();
      for (let i = 0; i < tmp_all_nodes.length; i++) {
        let tmp_node = tmp_all_nodes[i];
        if (strFunc.str_in_array(tmp_node.data["a_seq"], user_seq_arr) != -1) {
          tmp_node.setSelected(false);
        }
      }
    }
  };

  const setSelectFalseByMatchColVal = (inData: any) => {
    let opt_obj = {
      col_val: {},
      ...inData
    };
    let col_val = opt_obj.col_val;
    if (listAggridRef.current) {
      let tmp_all_nodes = listAggridRef.current.getNodeRows();
      for (let i = 0; i < tmp_all_nodes.length; i++) {
        let tmp_node = tmp_all_nodes[i];
        let is_match = true;
        for (let key in col_val) {
          if (tmp_node.data[key] != col_val[key]) {
            is_match = false;
          }
        }
        if (is_match) {
          tmp_node.setSelected(false);
        }
      }
    }
  };

  const cellClickedListener = (params: any) => {
    var key = params.colDef.field;

  }

  const cellRenderer = useCallback((params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;
    if (key == "a_user_name") {
      render_str = render_str + " " + params.data["a_stu_total_code"];
    } else if (key == "row_view_class_name") {
      if (params.data.class_arr) {
        let class_name_arr = [];
        for (let i = 0; i < params.data.class_arr.length; i++) {
          class_name_arr.push(params.data.class_arr[i]["class_name"]);
        }
        render_str = class_name_arr.join(" / ");;
      }
    } else if (key == "row_view_stu_grade") {
      let school_name = strFunc.cut_str(params.data["a_school_name"], 2, " ");
      let stu_grade_str = params.data["a_stu_grade"];
      if (xColumnArr.select_arr["a_stu_grade"]) {
        for (let i = 0; i < xColumnArr.select_arr["a_stu_grade"].length; i++) {
          if (xColumnArr.select_arr["a_stu_grade"][i]["value"] == params.data["a_stu_grade"]) {
            stu_grade_str = xColumnArr.select_arr["a_stu_grade"][i]["text"];
          }
        }
      }
      //xColumnArr
      render_str = school_name + stu_grade_str;
    } else if (key == "row_view_discover_map") {
      if (params.data["discover_map_arr"] && params.data["discover_map_arr"].length > 0) {
        let last_discover_map: any = params.data["discover_map_arr"][0];
        render_str = (
          <div>
            {last_discover_map["a_date"].substring(0, 10)}
            <button className="btn btn-dark ml-2"
              onClick={() => {
                myProps.discover_select({
                  stu_info: params.data,
                  discover_map_arr: params.data["discover_map_arr"],
                  discover_map: last_discover_map
                });
              }}>수정</button>
            ({params.data["discover_map_arr"].length})
            <button className="btn btn-red ml-1"
              onClick={() => {
                myProps.discover_delete({
                  discover_map: last_discover_map
                });
              }}>삭제</button>
          </div>
        );
      }
    } else if (key == "row_view_discover_map_view") {
      if (params.data["discover_map_arr"] && params.data["discover_map_arr"].length > 0) {
        let last_discover_map: any = params.data["discover_map_arr"][0];
        let tmp_success_cnt = 0;
        for (let i = 0; i < params.data["discover_map_arr"].length; i++) {
          let tmp_item = params.data["discover_map_arr"][i];
          if (tmp_item["a_is_success"] == "1") {
            tmp_success_cnt++;
          }
        }
        render_str = (
          <div>
            <span>{tmp_success_cnt}/{params.data["discover_map_arr"].length}</span>
            <span className="ml-1">{last_discover_map["a_date"].substring(0, 10)}</span>
          </div>
        );
      }
    } else if (key == "row_view_counsel_cnt") {
      if (params.data.ctodo_tot_info) {
        let tot_span_style: any = {
          display: "inline-block",
          textAlign: "center",
          lineHeight: "26px",
          height: "26px",
          padding: "0px 8px",
          background: "gray",
          color: "#fff",
          borderRadius: "5px"
        };
        if (params.data.ctodo_tot_info["tot"] > 0) {
          tot_span_style["background"] = "#db6c58";
          if (params.data.ctodo_tot_info["success_tot"] > 0) {
            tot_span_style["background"] = "#eab358";
            if (params.data.ctodo_tot_info["tot"] == params.data.ctodo_tot_info["success_tot"]) {
              tot_span_style["background"] = "#a2b854";
            }
          }
        }
        render_str = (
          <div style={tot_span_style}>
            {params.data.ctodo_tot_info &&
              <span>
                {params.data.ctodo_tot_info["no_progress_success_tot"] + "/" + params.data.ctodo_tot_info["no_progress_tot"]}
                {params.data.ctodo_tot_info["progress_tot"] &&
                  <span>(Daily {params.data.ctodo_tot_info["progress_tot"]})</span>
                }
              </span>
            }
          </div>
        );
      }
    } else if (key == "row_view_recent_councel") {
      if (params.data.add_memo_info && !strFunc.is_empty(params.data.add_memo_info["a_counsel_todo_recent_seq"])) {
        let tmp_recent_councel_date = DateFunc.get_date_format(new Date(params.data.add_memo_info["a_counsel_todo_recent_date"]), "Y-m-d");
        render_str = tmp_recent_councel_date.substring(5, 10);
        render_str = (
          <span title={tmp_recent_councel_date}>{render_str}</span>
        );
      }
    } else if (key == "row_view_attend") {
      let attend_in_btns = getAttendInCellRenderBtns(params);
      render_str =
        <div>
          {attend_in_btns}
        </div>;
    } else if (key == "row_view_attend_in_memo") {
      if (params.data.attend_in_arr && params.data.attend_in_arr.length > 0) {
        render_str = params.data.attend_in_arr[0]["a_memo"];
        if (render_str == "직접체크") {
          render_str = "";
        }
      }
    } else if (key == "row_view_plan") {
      render_str = "";
      if (params.data.todo_arr) {
        let todo_span_color = "#777";
        let todo_row_tot_data = {
          "tot": params.data.todo_arr.length,
          "success": 0,
        };
        for (let i = 0; i < todo_row_tot_data["tot"]; i++) {
          if (params.data.todo_arr[i]["a_is_success"] == "1") {
            todo_row_tot_data["success"]++;
          }
        }
        if (todo_row_tot_data["tot"] > 0) {
          todo_span_color = "#db6c58";
          if (todo_row_tot_data["success"]) {
            todo_span_color = "#eab358";
          } else if (todo_row_tot_data["success"] == todo_row_tot_data["tot"]) {
            todo_span_color = "#A2B854";
          }
        }
        render_str = (
          <span style={{ color: todo_span_color }}>
            {todo_row_tot_data.success + "/" + todo_row_tot_data.tot}
          </span>
        );
      }
    } else if (key == "row_view_textbook_use") {
      render_str = "";
      if (params.data.textbook_use_arr && params.data.textbook_use_arr.length > 0) {
        render_str = (
          <span>
            {params.data.textbook_use_arr.length}개
          </span>
        );
      }
    }
    return render_str;
  }, []);

  const onSelectionChanged = (event: any) => {
    let selected_row = listAggridRef.current.getSelectedRows();
    let select_seq_arr = [];
    if (selected_row) {
      for (let i = 0; i < selected_row.length; i++) {
        select_seq_arr.push(selected_row[i]["a_seq"]);
      }
    }
    myProps.list({
      now_page: 1,
      "s_stu_user_seq": select_seq_arr,
      select_stu_info_arr: selected_row
    });
  };
  let list_tot_cnt = 0;
  if (myProps.is_use_paging) {
    list_tot_cnt = countInfo.tot;
  } else {
    list_tot_cnt = infoArr.length;
  }
  return (
    <div>
      {myProps.is_show_title &&
        <div className="search-box-title">
          {myProps.title_str &&
            <span>{myProps.title_str}</span>
          }
          {myProps.title_center_str &&
            myProps.title_center_str
          }
          <span className="search-box-title-right-text">[총 {list_tot_cnt}명]</span>
        </div>
      }
      <SearchArea
        xColumnArr={xColumnArr}
        listOpt={listOpt}
        setListOpt={setListOpt}
        list={list}
        is_show_search_area={myProps.is_show_search_area}
        show_search_key_arr={myProps.show_search_key_arr}
        search_bottom_area={myProps.search_bottom_area}
      ></SearchArea>
      <ListAggrid
        ref={listAggridRef}
        infoArr={infoArr}
        xColumnArr={{ ...xColumnArr }}
        list={list}
        gridOpt={{
          fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
          is_idx_num: false,
          is_add_checkbox: false,
          floatingFilter: false,
          rowMultiSelectWithClick: true,
          rowSelection: "multiple",
          domLayout: "autoHeight",
          height: "",
          onGridReady: () => {

          },
          onCellClicked: cellClickedListener,
          cellRenderer: cellRenderer,
          onSelectionChanged: onSelectionChanged,
          ...myProps.grid_opt
        }}
      ></ListAggrid>
      {myProps.is_use_paging &&
        <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          is_show_total_rec={true}
          onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
      }
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "add_attend" &&
            <AddAttendPopup attend_sort={popupData.attend_sort} attend_sort_detail={popupData.attend_sort_detail}
              attend_date={popupData.attend_date}
              userInfoArr={popupData.userInfoArr}
              callback={() => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></AddAttendPopup>
          }
        </LayerPopup>
      }
    </div>
  );
});

export default FindStudentList;